import { axiosInstance } from ".";

const getNotificationsList = async ({ params }) =>
  await axiosInstance.get(`/api/Notification/GetNotifications`, {
    params
  });

const setNotificationSeen = async (data) =>
  await axiosInstance.put(
    `/api/Notification/MarkNotificationReaded`,
    data
  );

const setAllNotificationsSeen = async () =>
  await axiosInstance.get(
    `/api/Notification/MarkAllNotificationReaded`
  );

const getUnseenNotificationsCount = async () =>
  await axiosInstance.get(
    `/api/Notification/GetUnreadNotificationsCount`
  );

export {
  getNotificationsList,
  setNotificationSeen,
  setAllNotificationsSeen,
  getUnseenNotificationsCount
};
